import {useProjectsByIdQuery} from '../../redux/projects.api';
import {useProjectByIdQuery} from '../../redux/solution-contract.api';
import useProjectTokens from './useProjectTokens';

const useProjectById = (projectId: string) => {
  const {data: project} = useProjectsByIdQuery(projectId);
  const {data: projectBc, isSuccess: isSuccessProject} = useProjectByIdQuery(['', project?.blockchainId || '0'], {
    skip: !project,
  });

  const {tokens} = useProjectTokens(project);

  return {
    projectBc,
    project,
    tokens,
  };
};

export default useProjectById;
